import React, { Children, useState } from 'react';

import { Header, Box, Container } from '@amzn/awsui-components-console';

import PAGES from '../../nav/Pages';
import { iRecentPage, HS_RECENT_PAGES } from 'src/commons';
import { DataTypes } from 'src/interfaces/reduxInterfaces';
import InternalLink from '../helpers/InternalLink';

/**
 * A helper function which will generate the appropriately formatted href for each dataType, given its dataIds
 *
 * @param {DataType} type The DataType of the page (e.g. 'pipeline', 'activity', 'instance')
 * @returns The complete path to the defined resource
 */
function hrefByDataType(type: iRecentPage['type']): string {
	switch (type) {
		case 'activity':
			return PAGES.VIEW_ACTIVITY.path;
		case 'pipeline':
			return PAGES.VIEW_PIPELINE.path;
		case 'instance':
			return PAGES.VIEW_INSTANCE.path;
		default:
			return '/';
	}
}

export const RecentPages = () => {
	const [recentPages] = useState(window?.localStorage?.getItem(HS_RECENT_PAGES));

	if (!recentPages) {
		return null;
	}

	return (
		<Container header={<Header variant="h2">Recent pages</Header>}>
			<ul aria-label="Recent Pages" className="custom-list-separator">
				{Children.toArray(
					JSON.parse(recentPages).map(({ title, type, dataIds }: iRecentPage) => {
						const { groupName, ...pathParams } = dataIds;
						return (
							<li>
								<Box variant="span" color="text-body-secondary">
									{DataTypes[type]}{' '}
									<InternalLink
										href={hrefByDataType(type)}
										pathParams={pathParams}
										groupName={groupName}
									>
										{title}
									</InternalLink>
								</Box>
							</li>
						);
					})
				)}
			</ul>
		</Container>
	);
};
